import { Pipe, PipeTransform } from "@angular/core";
import { filter } from "lodash";

@Pipe({ name: 'filteredProduct' })
export class FilteredProductPipe implements PipeTransform {
    transform(orders: any, uiStates: any): any {
        if (!orders || !uiStates || !Array.isArray(orders) || typeof uiStates !== 'object') return [];
        return filter(orders, (o) => { return uiStates[o.Id]?.FilteredOrderProducts > 0 });
    }
}
